import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createTeamMember } from "../api/team.api";
import { uploadImage, uploadPdf } from "../api/upload.api";

export default function AddTeam() {
  const navigate = useNavigate();
  const [imageFile, setImageFile] = useState(null);
  const [pdfFile, setPdfFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    name: "",
    category: "member",
    position: "",
    education: "",
    bio: "",
    cv: "",
    photo: ""
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (!imageFile) {
        alert("Image is required");
        setLoading(false);
        return;
      }

      // Upload image
      const imageName = await uploadImage(imageFile);
      if (!imageName) throw new Error("Image upload failed");

      // Upload CV (optional but required in your form)
      if (!pdfFile) {
        throw new Error("CV file is required");
      }
      const pdfName = await uploadPdf(pdfFile);
      if (!pdfName) throw new Error("CV upload failed");

      // Update form with filenames
      const payload = {
        ...form,
        photo: imageName,
        cv: pdfName,
      };

      await createTeamMember(payload);
      alert("Team member added successfully!");
      navigate("/admin/team");
    } catch (err) {
      console.error(err);
      alert("Failed to add team member");
    } finally {
      setLoading(false);
    }
  };
  


  return (
    <div className="container py-5">
      <h2>Add Team Member</h2>
      <form onSubmit={handleSubmit}>
        <input name="name" placeholder="Name" value={form.name} onChange={handleChange} className="form-control mb-2" />
        <select name="category" value={form.category} onChange={handleChange} className="form-control mb-2">
          <option value="membership">Membership</option>
          <option value="leadership">Leadership</option>
        </select>
        <input name="position" placeholder="Position" value={form.position} onChange={handleChange} className="form-control mb-2" />
        <input name="education" placeholder="Education" value={form.education} onChange={handleChange} className="form-control mb-2" />
        <textarea name="bio" placeholder="Bio" value={form.bio} onChange={handleChange} className="form-control mb-2" />
        
        <input 
        type="file"
        accept="application/pdf"
        onChange={(e) => setPdfFile(e.target.files[0])} 
        className="form-control mb-2" 
        required
        />

        <input 
        type="file"
        accept="image/*"
        onChange={(e) => setImageFile(e.target.files[0])}
        className="form-control mb-2" 
        />
        
        <button type="submit" className="btn btn-success">Save</button>
      </form>
    </div>
  );
}
